import { Modal } from 'components/atoms/Modal';
import { AnimatePresence } from 'motion/react';
import { FC, useMemo } from 'react';
import globalModalsController from './globalModalsController';

const GlobalModalsRoot: FC = () => {
  const modals = globalModalsController.useModals();

  const modalsArray = useMemo(
    () =>
      Object.values(modals).map((config) => {
        return (
          <Modal
            {...config.options}
            name={config.id}
            key={config.id}
            defaultOpen
            propagateExitAnimation
            render={(api) => config.render({ id: config.id, ...api })}
            onClose={() => {
              globalModalsController.closeModal(config.id);
              config.options?.onClose?.();
            }}
          />
        );
      }),
    [modals],
  );

  return <AnimatePresence>{modalsArray}</AnimatePresence>;
};

export default GlobalModalsRoot;
